import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const CheckOutDoc1Icon = ({ size, className, ...other }) => (
  /* eslint-disable */

  <div
    className={clsx(
      "em-c-icon",
      {
        "em-c-icon--small": size === "small",
        "em-c-icon--medium": size !== "small" && size !== "large",
        "em-c-icon--large": size === "large"
      },
      "em-icon-wrapper",
      className
    )}
    {...other}
  >
    {size === "small" ? (
      <svg height="100%" width="100%" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M8 6h1v4H8zM15.5 16h-14a.5.5 0 0 1-.5-.5V13h1v2h13v-2h1v2.5a.5.5 0 0 1-.5.5z"
        />
        <path
          d="M10.48 6.784L8.5 4.8 6.52 6.784l-.707-.707 2.333-2.334a.5.5 0 0 1 .707 0l2.333 2.333z"
          fill="currentColor"
        />
        <path
          d="M12.5 13h-8A1.5 1.5 0 0 1 3 11.5v-10A1.5 1.5 0 0 1 4.5 0h5.165A1.493 1.493 0 0 1 10.7.411l2.835 2.68A1.507 1.507 0 0 1 14 4.181V11.5a1.5 1.5 0 0 1-1.5 1.5zm-8-12a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.181a.5.5 0 0 0-.157-.363l-2.835-2.681A.5.5 0 0 0 9.665 1z"
          fill="currentColor"
        />
      </svg>
    ) : size === "large" ? (
      <svg height="100%" width="100%" viewBox="0 0 48 48">
        <path
          d="M43 48H3a3 3 0 0 1-3-3v-5h2v5a1 1 0 0 0 1 1h40a1 1 0 0 0 1-1v-5h2v5a3 3 0 0 1-3 3z"
          fill="currentColor"
        />
        <path
          d="M37 42H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h18.343a4.967 4.967 0 0 1 3.535 1.464l7.657 7.657A4.967 4.967 0 0 1 40 12.657V39a3 3 0 0 1-3 3zM9 2a1 1 0 0 0-1 1v36a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V12.657a3.022 3.022 0 0 0-.878-2.121l-7.658-7.658A3.022 3.022 0 0 0 27.343 2z"
          fill="currentColor"
        />
        <path fill="currentColor" d="M22 16h2v16h-2z" />
        <path
          d="M30.02 20.414l-6.3-6.128a1.036 1.036 0 0 0-1.434 0l-6.3 6.128-1.4-1.434 6.3-6.127a3.049 3.049 0 0 1 4.223 0l6.3 6.127z"
          fill="currentColor"
        />
      </svg>
    ) : (
      <svg height="100%" width="100%" viewBox="0 0 24 24">
        <path
          d="M23 24H1a1 1 0 0 1-1-1v-4h2v3h20v-3h2v4a1 1 0 0 1-1 1z"
          fill="currentColor"
        />
        <path
          d="M19 21H5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9.171a2.98 2.98 0 0 1 2.122.879l3.414 3.414A4.515 4.515 0 0 1 21 6.829V19a2 2 0 0 1-2 2zM5 2v17h14V6.829a3.387 3.387 0 0 0-.707-1.122l-3.414-3.414A.994.994 0 0 0 14.171 2z"
          fill="currentColor"
        />
        <path fill="currentColor" d="M11 8.444h2v9h-2z" />
        <path
          d="M16 10.858l-3.707-3.707c-.112-.111-.281-.28-.6.013L8 10.858 6.586 9.444l3.707-3.707a2.346 2.346 0 0 1 3.414 0l3.707 3.707z"
          fill="currentColor"
        />
      </svg>
    )}
  </div>

  /* eslint-enable */
);

CheckOutDoc1Icon.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** className allows you to append css classes */

  className: PropTypes.string
};

CheckOutDoc1Icon.defaultProps = {
  size: "medium",

  className: ""
};

export default CheckOutDoc1Icon;
